export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/hand_drawn-pattern.b332d60.svg";